var _classCallCheck = require("/opt/build/repo/postcard-editor/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/postcard-editor/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/postcard-editor/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/postcard-editor/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/postcard-editor/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/opt/build/repo/postcard-editor/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _wrapNativeSuper = require("/opt/build/repo/postcard-editor/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _slicedToArray = require("/opt/build/repo/postcard-editor/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/opt/build/repo/postcard-editor/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* 
Tool Cool Range Slider 
Version: 4.0.17
Documentation: https://github.com/toolcool-org/toolcool-range-slider 
License: MIT License        
Author: Tool Cool, toolcool.org@gmail.com>                          
*/
(function () {
  var Nn = Object.defineProperty;

  var vt = Math.pow,
      Vn = function Vn(r, i, t) {
    return i in r ? Nn(r, i, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : r[i] = t;
  };

  var ie = function ie(r, i, t) {
    return Vn(r, typeof i != "symbol" ? i + "" : i, t), t;
  };

  var yt = function yt(r, i) {
    return " ".concat(i && i.length > 0 ? i.map(function (t) {
      return "<link rel=\"stylesheet\" href=\"".concat(t, "\" />");
    }).join("") : "", " <style> ").concat(r, " </style> <div class=\"range-slider-box\"> <div class=\"row\"> <div id=\"range-slider\" class=\"range-slider\"> <div class=\"container\"> <div class=\"panel\"></div> <div class=\"panel-fill\"></div> <div class=\"container\"> <div class=\"pointer\" tabindex=\"0\" role=\"slider\"> <div class=\"pointer-shape\"></div> </div> </div> </div> </div> </div> </div>");
  };

  var xt = ":host{--width:300px;--height:.25rem;--opacity:.4;--panel-bg:#cbd5e1;--panel-bg-hover:#94a3b8;--panel-bg-fill:#475569;--panel-bg-border-radius:1rem;--pointer-width:1rem;--pointer-height:1rem;--pointer-bg:#fff;--pointer-bg-hover:#dcdcdc;--pointer-bg-focus:#dcdcdc;--pointer-shadow:0 0 2px rgba(0,0,0,0.8);--pointer-shadow-hover:0 0 2px #000;--pointer-shadow-focus:var(--pointer-shadow-hover);--pointer-border:1px solid hsla(0,0%,88%,0.5);--pointer-border-hover:1px solid #94a3b8;--pointer-border-focus:var(--pointer-border-hover);--pointer-border-radius:100%;--animate-onclick:.3s}:host{max-width:100%}.range-slider-box{display:flex;position:relative;flex-direction:column}.range-slider{position:relative;width:var(--width,100%);height:var(--height,0.25rem);touch-action:none;max-width:100%;box-sizing:border-box;cursor:pointer}.row{width:100%;display:flex;align-items:center}.range-slider.disabled{opacity:var(--opacity,0.4);cursor:default}.pointer.disabled{-webkit-filter:brightness(0.8);filter:brightness(0.8);cursor:default}.range-slider *{box-sizing:border-box}.container{position:absolute;width:100%;height:100%}.panel{position:absolute;z-index:10;width:100%;height:100%;background:var(--panel-bg,#2d4373);border-radius:var(--panel-bg-border-radius,1rem);overflow:hidden;transition:.3s all ease}.panel-fill{background:var(--panel-bg-fill,#000);border-radius:var(--panel-bg-border-radius,1rem);overflow:hidden;height:100%;position:absolute;z-index:10}.panel:hover{background:var(--panel-bg-hover,#5f79b7)}.disabled .panel:hover{background:var(--panel-bg,#5f79b7)}.pointer{position:absolute;z-index:20;outline:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.pointer-shape{background:var(--pointer-bg,#fff);background-size:contain;box-shadow:var(--pointer-shadow);border:var(--pointer-border);border-radius:var(--pointer-border-radius,100%);-webkit-transform:translateX(-50%);transform:translateX(-50%);width:var(--pointer-width,15px);height:var(--pointer-height,15px);transition:.3s all ease}.pointer-shape:hover{background:var(--pointer-bg-hover,#fff);background-size:contain;border:var(--pointer-border-hover);box-shadow:var(--pointer-shadow-hover)}.disabled .pointer-shape:hover{background:var(--pointer-bg,#fff);background-size:contain;border:var(--pointer-border);box-shadow:var(--pointer-shadow)}.pointer:focus .pointer-shape{background:var(--pointer-bg-focus,#fff);background-size:contain;border:var(--pointer-border-focus);box-shadow:var(--pointer-shadow-focus)}.disabled .pointer:focus .pointer-shape{background:var(--pointer-bg,#fff);background-size:contain;border:var(--pointer-border);box-shadow:var(--pointer-shadow)}.type-vertical .range-slider{--width:.25rem;--height:300px;max-height:100%}.type-vertical .range-slider .pointer{left:50%}.type-vertical .range-slider .panel-fill{width:100%}.type-vertical.range-slider-box{flex-direction:row}.type-vertical .row{flex-direction:column}.animate-on-click .pointer,.animate-on-click .panel-fill{transition:all var(--animate-onclick)}.range-dragging .panel-fill{cursor:move}";
  var oe = "pointers-overlap",
      se = "pointers-min-distance",
      ae = "pointers-max-distance",
      le = "range-dragging",
      ue = "data",
      de = "min",
      ce = "max",
      pe = "step",
      be = "round",
      ge = "type",
      fe = "theme",
      me = "rtl",
      he = "btt",
      ve = "disabled",
      ye = "keyboard-disabled",
      Pt = "slider-width",
      St = "slider-height",
      Et = "slider-radius",
      Tt = "slider-bg",
      At = "slider-bg-hover",
      Mt = "slider-bg-fill",
      Lt = "pointer-width",
      wt = "pointer-height",
      Dt = "pointer-radius",
      Ct = "pointer-bg",
      kt = "pointer-bg-hover",
      Ht = "pointer-bg-focus",
      Rt = "pointer-shadow",
      It = "pointer-shadow-hover",
      Bt = "pointer-shadow-focus",
      Ot = "pointer-border",
      Ft = "pointer-border-hover",
      Nt = "pointer-border-focus",
      xe = "animate-onclick",
      Vt = "css-links";
  var I = "vertical",
      N = "horizontal";

  var Ee = function Ee(r, i, t, n, s) {
    var d = i - r;
    return d === 0 ? t : (n - t) * (s - r) / d + t;
  },
      B = function B(r) {
    return !isNaN(parseFloat(r)) && isFinite(r);
  },
      E = function E(r, i) {
    return B(r) ? Number(r) : i;
  },
      Xe = function Xe(r, i) {
    return i === 0 ? 0 : Math.round(r / i) * i;
  },
      Ut = function Ut(r) {
    var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1 / 0;
    if (i === 1 / 0) return r;
    var t = vt(10, i);
    return Math.round(r * t) / t;
  },
      D = function D(r) {
    return r == null ? !1 : typeof r == "boolean" ? r : r.trim().toLowerCase() === "true";
  };

  var zt = function zt(r, i) {
    r.dispatchEvent(new CustomEvent("onPointerClicked", {
      detail: {
        $pointer: i
      }
    }));
  },
      Wt = function Wt(r, i) {
    r.dispatchEvent(new CustomEvent("onMouseDown", {
      detail: {
        nativeEvent: i
      }
    }));
  },
      Kt = function Kt(r, i) {
    r.dispatchEvent(new CustomEvent("onMouseUp", {
      detail: {
        nativeEvent: i
      }
    }));
  },
      jt = function jt(r, i) {
    r.dispatchEvent(new CustomEvent("onKeyDown", {
      detail: {
        nativeEvent: i
      }
    }));
  },
      qt = function qt(r, i) {
    if (!i || i.length <= 0) return;
    var t = i.map(function (s) {
      return B(s) ? E(s, s) : s;
    }),
        n = {
      values: t || []
    };
    n.value = t[0], n.value0 = t[0], n.value1 = t[0];

    for (var s = 1; s < t.length; s++) {
      n["value".concat(s + 1)] = t[s];
    }

    r.dispatchEvent(new CustomEvent("change", {
      detail: n
    }));
  };

  var X = function X(r, i, t) {
    var n = 0,
        s,
        d,
        m,
        l,
        a = !1,
        f = function f(g, T, w, P, M, H) {
      w !== void 0 && g > w && (g = w), T !== void 0 && g < T && (g = T), n = g;
      var C = n;
      (P === I && H || P === N && M) && (C = 100 - C), P === I ? i.style.top = "".concat(C, "%") : i.style.left = "".concat(C, "%");
    },
        x = function x(g) {
      return g === i || i.contains(g);
    },
        p = function p(g, T, w, P) {
      s = g, d = T, m = w, l = P;
    },
        b = function b(g) {
      a = g, i.classList.toggle("disabled", a), a ? i.setAttribute("aria-disabled", "true") : i.hasAttribute("aria-disabled") && i.removeAttribute("aria-disabled");
    },
        A = function A(g, T) {
      T == null ? i.removeAttribute(g) : i.setAttribute(g, T);
    },
        k = function k(g) {
      return i.getAttribute(g);
    },
        c = function c(g) {
      if (!a) {
        switch (g.key) {
          case "ArrowLeft":
            {
              g.preventDefault(), typeof s == "function" && s(t);
              break;
            }

          case "ArrowRight":
            {
              g.preventDefault(), typeof d == "function" && d(t);
              break;
            }

          case "ArrowUp":
            {
              g.preventDefault(), typeof m == "function" && m(t);
              break;
            }

          case "ArrowDown":
            {
              g.preventDefault(), typeof l == "function" && l(t);
              break;
            }
        }

        jt(r, g);
      }
    },
        h = function h() {
      a || zt(r, i);
    };

    return i.className = "pointer pointer-".concat(t), i.addEventListener("keydown", c), i.addEventListener("click", h), {
      $pointer: i,

      get percent() {
        return n;
      },

      get disabled() {
        return a;
      },

      set disabled(g) {
        b(g);
      },

      updatePosition: f,
      isClicked: x,
      setCallbacks: p,
      setAttr: A,
      getAttr: k,
      destroy: function destroy() {
        i.removeEventListener("keydown", c), i.removeEventListener("click", h), i.remove();
      }
    };
  };

  var Gt = function Gt(r) {
    if (r == null) return;
    if (Array.isArray(r)) return r;
    if (r.trim() === "") return;
    var t = r.split(","),
        n = [],
        s = !0;

    for (var d = 0; d < t.length; d++) {
      var m = t[d].trim();
      m !== "" && (n.push(m), B(m) || (s = !1));
    }

    return s ? n.map(function (d) {
      return Number(d);
    }) : n;
  },
      Xt = function Xt(r, i) {
    return i ? i.findIndex(function (t) {
      return t === r || t.toString().trim() === r.toString().trim();
    }) : -1;
  };

  var Yt = function Yt(r) {
    return {
      updatePosition: function updatePosition(t, n, s, d) {
        if (n.length <= 0) return;
        var m = n.length === 1,
            l = n[0],
            a = n[n.length - 1];
        t === I ? (r.style.removeProperty("width"), r.style.removeProperty("right"), r.style.removeProperty("left"), m ? r.style.height = "".concat(l, "%") : r.style.height = "".concat(Math.abs(l - a), "%"), d ? (r.style.bottom = "0%", m ? r.style.top = "auto" : r.style.top = "".concat(Math.min(100 - a, 100 - l), "%")) : (r.style.bottom = "auto", m ? r.style.top = "0%" : r.style.top = "".concat(Math.min(l, a), "%"))) : (r.style.removeProperty("height"), r.style.removeProperty("top"), r.style.removeProperty("bottom"), m ? r.style.width = "".concat(l, "%") : r.style.width = "".concat(Math.abs(l - a), "%"), s ? (r.style.right = "0%", m ? r.style.left = "auto" : r.style.left = "".concat(Math.min(100 - a, 100 - l), "%")) : (r.style.right = "auto", m ? r.style.left = "0%" : r.style.left = "".concat(Math.min(l, a), "%")));
      }
    };
  };

  var Ye = "--animate-onclick",
      Jt = "--width",
      Qt = "--height",
      Zt = "--panel-bg-border-radius",
      _t = "--panel-bg",
      $t = "--panel-bg-hover",
      en = "--panel-bg-fill",
      tn = "--pointer-width",
      nn = "--pointer-height",
      rn = "--pointer-border-radius",
      on = "--pointer-bg",
      sn = "--pointer-bg-hover",
      an = "--pointer-bg-focus",
      ln = "--pointer-shadow",
      un = "--pointer-shadow-hover",
      dn = "--pointer-shadow-focus",
      cn = "--pointer-border",
      pn = "--pointer-border-hover",
      bn = "--pointer-border-focus";

  var j = function j(r, i, t) {
    var n = new Map();

    var _iterator = _createForOfIteratorHelper(r.attributes),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var s = _step.value;
        var d = s.nodeName.trim().toLowerCase();
        if (!i.test(d)) continue;
        var l = d.replace(/\D/g, "").trim(),
            a = l === "" || l === "0" || l === "1" ? 0 : E(l, 0) - 1,
            f = t && typeof t == "function" ? t(s.value) : s.value;
        n.set(a, f);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return n;
  },
      fn = function fn(r) {
    if (!r) return null;
    var i = r.getAttribute(Vt);
    if (!i) return null;
    var t = i.split(";"),
        n = [];

    var _iterator2 = _createForOfIteratorHelper(t),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var s = _step2.value;
        s.trim() !== "" && n.push(s.trim());
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return n;
  };

  var Je = [[Jt, Pt, "sliderWidth", null], [Qt, St, "sliderHeight", null], [Zt, Et, "sliderRadius", null], [_t, Tt, "sliderBg", null], [$t, At, "sliderBgHover", null], [en, Mt, "sliderBgFill", null], [tn, Lt, "pointer#Width", /^pointer([0-9]*)-width$/], [nn, wt, "pointer#Height", /^pointer([0-9]*)-height$/], [rn, Dt, "pointer#Radius", /^pointer([0-9]*)-radius$/], [on, Ct, "pointer#Bg", /^pointer([0-9]*)-bg$/], [sn, kt, "pointer#BgHover", /^pointer([0-9]*)-bg-hover$/], [an, Ht, "pointer#BgFocus", /^pointer([0-9]*)-bg-focus$/], [ln, Rt, "pointer#Shadow", /^pointer([0-9]*)-shadow$/], [un, It, "pointer#ShadowHover", /^pointer([0-9]*)-shadow-hover$/], [dn, Bt, "pointer#ShadowFocus", /^pointer([0-9]*)-shadow-focus$/], [cn, Ot, "pointer#Border", /^pointer([0-9]*)-border$/], [pn, Ft, "pointer#BorderHover", /^pointer([0-9]*)-border-hover$/], [bn, Nt, "pointer#BorderFocus", /^pointer([0-9]*)-border-focus$/]],
      mn = function mn(r, i, t) {
    var n = null,
        s = [],
        d = new Map(),
        m = function m(c) {
      var h = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : i;

      var L = _toConsumableArray(h.classList);

      var _iterator3 = _createForOfIteratorHelper(L),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var g = _step3.value;
          g.startsWith(c) && i.classList.remove(g);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    },
        l = function l() {
      m("shape");
      var c = i.querySelectorAll(".pointer");

      var _iterator4 = _createForOfIteratorHelper(c),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var h = _step4.value;
          m("shape", h);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    },
        a = function a(c) {
      n = c, m("theme-"), typeof c == "string" && i.classList.add("theme-".concat(c));
    },
        f = function f() {
      if (l(), !(s.length <= 0)) {
        i.classList.add("shape", "shape-".concat(s[0]));

        for (var c = 1; c < s.length; c++) {
          var h = s[c];
          if (!h) continue;
          var L = i.querySelector(".pointer-".concat(c));
          !L || L.classList.add("shape", "shape-".concat(h));
        }
      }
    },
        x = function x(c, h) {
      s[c] = h, f();
    },
        p = function p() {
      l();
      var c = j(r, /^pointer([0-9]*)-shape$/);

      if (!(c.size <= 0)) {
        var _iterator5 = _createForOfIteratorHelper(c),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var h = _step5.value;
            var L = h[0];
            s[L] = h[1];
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        f();
      }
    },
        b = function b(c, h) {
      return "".concat(c, "-").concat(h);
    },
        A = function A(c, h, L) {
      var g = t[L];
      if (!g) return;
      var T = L === 0 ? i : g.$pointer;

      if (h == null) {
        d.has(b(c, L)) && d.delete(b(c, L)), T.style.removeProperty(c);
        return;
      }

      d.set(b(c, L), h), T.style.setProperty(c, h);
    },
        k = function k(c, h) {
      return d.get(b(c, h));
    };

    return function () {
      var _iterator6 = _createForOfIteratorHelper(Je),
          _step6;

      try {
        var _loop = function _loop() {
          var c = _step6.value;

          var _c = _slicedToArray(c, 4),
              h = _c[0],
              L = _c[1],
              g = _c[2],
              T = _c[3];

          if (T) {
            var P = j(r, T);

            var _iterator7 = _createForOfIteratorHelper(P),
                _step7;

            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                var M = _step7.value;
                var H = M[0],
                    C = M[1];
                A(h, C, H);
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
          } else {
            var _P = r.getAttribute(L);

            A(h, _P, 0);
          }

          var w = [];
          if (g.indexOf("#") === -1) w.push([g, 0]);else {
            w.push([g.replace("#", ""), 0]), w.push([g.replace("#", "0"), 0]), w.push([g.replace("#", "1"), 0]);

            for (var _P2 = 1; _P2 < t.length; _P2++) {
              w.push([g.replace("#", (_P2 + 1).toString()), _P2]);
            }
          }

          for (var _i = 0, _w = w; _i < _w.length; _i++) {
            var _P3 = _w[_i];

            try {
              (function () {
                var M = _P3[0],
                    H = _P3[1];
                Object.prototype.hasOwnProperty.call(r, M) || Object.defineProperty(r, M, {
                  get: function get() {
                    return k(h, H);
                  },
                  set: function set(C) {
                    A(h, C, H);
                  }
                });
              })();
            } catch (M) {
              console.error(M);
            }
          }
        };

        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      a(r.getAttribute(fe)), p();
    }(), {
      setStyle: A,
      getStyle: k,

      get theme() {
        return n;
      },

      set theme(c) {
        a(c);
      },

      get pointerShapes() {
        return s;
      },

      setPointerShape: x
    };
  };

  var W = "animate-on-click",
      Qe = "range-dragging";

  var hn = function hn(r, i, t, n) {
    var s = [],
        d = function d(p) {
      var _iterator8 = _createForOfIteratorHelper(s),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var b = _step8.value;
          b.update && typeof b.update == "function" && b.update(p);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    },
        m = function m() {
      var _iterator9 = _createForOfIteratorHelper(s),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var p = _step9.value;
          p.destroy && typeof p.destroy == "function" && p.destroy();
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    },
        l = function l(p, b) {
      var _iterator10 = _createForOfIteratorHelper(s),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var A = _step10.value;
          A.onAttrChange && typeof A.onAttrChange == "function" && A.onAttrChange(p, b);
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    },
        a = function a(p) {
      if (!!p.gettersAndSetters) {
        var _iterator11 = _createForOfIteratorHelper(p.gettersAndSetters),
            _step11;

        try {
          for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
            var b = _step11.value;
            if (!(!b.name || !b.attributes)) try {
              Object.prototype.hasOwnProperty.call(r, b.name) || Object.defineProperty(r, b.name, b.attributes);
            } catch (A) {
              console.error("defineSettersGetters error:", A);
            }
          }
        } catch (err) {
          _iterator11.e(err);
        } finally {
          _iterator11.f();
        }
      }
    },
        f = function f(p) {
      var A;
      if (!p.css) return;
      var b = (A = r.shadowRoot) == null ? void 0 : A.querySelector("style");
      !b || (b.innerHTML += p.css);
    };

    return {
      init: function init() {
        if (!!window.tcRangeSliderPlugins) {
          var _iterator12 = _createForOfIteratorHelper(window.tcRangeSliderPlugins),
              _step12;

          try {
            for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
              var p = _step12.value;
              var b = p();
              s.push(b), b.init && typeof b.init == "function" && (b.init(r, i, t, n), a(b), f(b));
            }
          } catch (err) {
            _iterator12.e(err);
          } finally {
            _iterator12.f();
          }
        }
      },
      update: d,
      onAttrChange: l,
      destroy: m
    };
  };

  var vn = function vn(r, i) {
    var t = new Map(),
        n = /^value([0-9]*)$/;

    var _iterator13 = _createForOfIteratorHelper(r.attributes),
        _step13;

    try {
      for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
        var _l = _step13.value;

        var _a = _l.nodeName.trim().toLowerCase();

        if (!n.test(_a)) continue;

        var x = _a.replace("value", "").trim(),
            p = x === "" || x === "0" || x === "1" ? 0 : E(x, 0) - 1,
            b = B(_l.value) ? E(_l.value, 0) : _l.value;

        t.set(p, b);
      }
    } catch (err) {
      _iterator13.e(err);
    } finally {
      _iterator13.f();
    }

    var s = Math.max.apply(Math, _toConsumableArray(Array.from(t.keys()))),
        d = [];
    d.push([X(r, i, 0), t.get(0)]);
    var m = i;

    for (var l = 1; l <= s; l++) {
      var a = i.cloneNode(!0);
      m.after(a), m = a, d.push([X(r, a, l), t.get(l)]);
    }

    return d;
  },
      Ze = function Ze(r, i, t, n, s, d, m) {
    try {
      Object.defineProperty(r, n, {
        configurable: !0,
        get: function get() {
          if (!i) return;
          var l = i.pointers[t];
          if (!l) return;
          var a = i.getTextValue(l.percent);
          return B(a) ? E(a, a) : a;
        },
        set: function set(l) {
          i == null || i.setValue(l, t);
        }
      }), Object.defineProperty(r, s, {
        configurable: !0,
        get: function get() {
          var l, a;
          return (a = (l = i == null ? void 0 : i.pointers[t]) == null ? void 0 : l.getAttr("aria-label")) != null ? a : void 0;
        },
        set: function set(l) {
          !i || i.setAriaLabel(t, l);
        }
      }), Object.defineProperty(r, d, {
        configurable: !0,
        get: function get() {
          var l, a;
          return (a = (l = i == null ? void 0 : i.styles) == null ? void 0 : l.pointerShapes[t]) != null ? a : null;
        },
        set: function set(l) {
          !i || !i.styles || i.styles.setPointerShape(t, l);
        }
      }), Object.defineProperty(r, m, {
        configurable: !0,
        get: function get() {
          var l;
          return (l = i == null ? void 0 : i.pointers[t].disabled) != null ? l : !1;
        },
        set: function set(l) {
          if (!i) return;
          var a = i == null ? void 0 : i.pointers[t];
          !a || (a.disabled = l);
        }
      });
    } catch (l) {
      console.error(l);
    }
  },
      yn = function yn(r, i) {
    var t = [["value", "ariaLabel", "pointerShape", "pointerDisabled", 0], ["value0", "ariaLabel0", "pointerShape0", "pointer0Disabled", 0], ["value1", "ariaLabel1", "pointerShape1", "pointer1Disabled", 0]];

    for (var n = 1; n < i.pointers.length; n++) {
      t.push(["value".concat(n + 1), "ariaLabel".concat(n + 1), "pointer".concat(n + 1, "Shape"), "pointer".concat(n + 1, "Disabled"), n]);
    }

    for (var _i2 = 0, _t2 = t; _i2 < _t2.length; _i2++) {
      var _n = _t2[_i2];
      Ze(r, i, _n[4], _n[0], _n[1], _n[2], _n[3]);
    }
  },
      _e = function _e(r, i, t) {
    var s;
    var n = (s = t.shadowRoot) == null ? void 0 : s.querySelector(".container");

    if (!!n) {
      var _iterator14 = _createForOfIteratorHelper(r),
          _step14;

      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var d = _step14.value;
          i ? n.prepend(d.$pointer) : n.append(d.$pointer);
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
    }
  };

  var $e = 0,
      Y = 100,
      U = 2,
      xn = "0.3s",
      Pn = function Pn(r, i, t) {
    var n = t.map(function (e) {
      return e[0];
    }),
        s = null,
        d = null,
        m = null,
        l = null,
        a = $e,
        f = Y,
        x,
        p,
        b = N,
        A = U,
        k = !1,
        c = !1,
        h = !1,
        L = 0,
        g = 1 / 0,
        T = !1,
        w,
        P,
        M = !1,
        H = !1,
        C = xn,
        tt = [],
        nt = function nt(e) {
      M || (e.preventDefault && e.preventDefault(), V(e), window.addEventListener("mousemove", V), window.addEventListener("mouseup", Ae), Wt(r, e));
    },
        Ae = function Ae(e) {
      M || (w = void 0, P = void 0, window.removeEventListener("mousemove", V), window.removeEventListener("mouseup", V), C && i.classList.add(W), Kt(r, e));
    },
        En = function En(e, o) {
      if (n.length <= 0) return;
      if (n.length === 1) return n[0].isClicked(e) && C && i.classList.remove(W), n[0];
      var u = An(e);

      if (T) {
        var S = o,
            F = J(S);
        F !== void 0 && (S = Xe(S, F)), u ? (w = S, P = 0, C && i.classList.remove(W)) : w !== void 0 && (P = S - w, w = S);
      }

      if (!Tn(e) && !u) {
        var _iterator15 = _createForOfIteratorHelper(n),
            _step15;

        try {
          for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
            var _S = _step15.value;
            if (!!_S.isClicked(e)) return C && i.classList.remove(W), _S;
          }
        } catch (err) {
          _iterator15.e(err);
        } finally {
          _iterator15.f();
        }

        var _iterator16 = _createForOfIteratorHelper(n),
            _step16;

        try {
          for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
            var _S2 = _step16.value;
            if (s === _S2) return _S2;
          }
        } catch (err) {
          _iterator16.e(err);
        } finally {
          _iterator16.f();
        }
      }

      var v = 1 / 0,
          y = null;

      var _iterator17 = _createForOfIteratorHelper(n),
          _step17;

      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var _S3 = _step17.value;

          var _F = Math.abs(o - _S3.percent);

          _F < v && (v = _F, y = _S3);
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }

      return y;
    },
        rt = function rt() {
      return n.findIndex(function (e) {
        return s === e && !e.disabled;
      });
    },
        V = function V(e) {
      var o;

      if (b === I) {
        var _i$getBoundingClientR = i.getBoundingClientRect(),
            v = _i$getBoundingClientR.height,
            y = _i$getBoundingClientR.top,
            S = e.type.indexOf("mouse") !== -1 ? e.clientY : e.touches[0].clientY;

        o = Math.min(Math.max(0, S - y), v) * 100 / v;
      } else {
        var _i$getBoundingClientR2 = i.getBoundingClientRect(),
            _v = _i$getBoundingClientR2.width,
            _y = _i$getBoundingClientR2.left,
            _S4 = e.type.indexOf("mouse") !== -1 ? e.clientX : e.touches[0].clientX;

        o = Math.min(Math.max(0, _S4 - _y), _v) * 100 / _v;
      }

      if ((k || c) && (o = 100 - o), s = En(e.target, o), T && n.length > 1 && P !== void 0) {
        var _v2 = n[0],
            _y2 = n[n.length - 1],
            _S5 = _v2.percent + P < 0,
            F = _y2.percent + P > 100;

        if (_S5 || F) return;

        for (var re = 0; re < n.length; re++) {
          R(re, n[re].percent + P);
        }

        return;
      }

      var u = rt();
      u !== -1 && (R(u, o), s == null || s.$pointer.focus());
    },
        it = function it(e) {
      if (M || document.activeElement !== r || (s == null ? void 0 : s.disabled)) return;
      e.stopPropagation(), e.preventDefault();
      var o = e.deltaY < 0,
          u = k || c,
          v = o ? !u : u,
          y = rt();
      y !== -1 && (v ? q(y, n[y].percent) : G(y, n[y].percent));
    },
        ot = function ot(e) {
      M || H || (b === I ? c ? R(e, 100) : R(e, 0) : k ? G(e, n[e].percent) : q(e, n[e].percent));
    },
        st = function st(e) {
      M || H || (b === I ? c ? R(e, 0) : R(e, 100) : k ? q(e, n[e].percent) : G(e, n[e].percent));
    },
        at = function at(e) {
      M || H || (b === I ? c ? G(e, n[e].percent) : q(e, n[e].percent) : k ? R(e, 100) : R(e, 0));
    },
        lt = function lt(e) {
      M || H || (b === I ? c ? q(e, n[e].percent) : G(e, n[e].percent) : k ? R(e, 0) : R(e, 100));
    },
        Tn = function Tn(e) {
      return e.classList.contains("panel");
    },
        An = function An(e) {
      return e.classList.contains("panel-fill");
    },
        q = function q(e, o) {
      if (o === void 0) return;
      var u = J(o);
      u == null && (u = 1), o -= u, o < 0 && (o = 0), R(e, o);
    },
        G = function G(e, o) {
      if (o === void 0) return;
      var u = J(o);
      u == null && (u = 1), o += u, o > 100 && (o = 100), R(e, o);
    },
        z = function z() {
      !l || l.update({
        percents: ut(),
        values: dt(),
        $pointers: ct(),
        min: pt(),
        max: bt(),
        data: Le(),
        step: Me(),
        round: De(),
        type: we(),
        textMin: Q(),
        textMax: Z(),
        rightToLeft: He(),
        bottomToTop: Re(),
        pointersOverlap: Oe(),
        pointersMinDistance: Ce(),
        pointersMaxDistance: ke(),
        rangeDragging: Fe(),
        disabled: Ie(),
        keyboardDisabled: Be()
      });
    },
        Mn = function Mn() {
      z();
    },
        Ln = function Ln(e) {
      if (!(h || n.length <= 1 || f === a)) if (e === 0) {
        var o = g * 100 / (f - a);
        return Math.max(0, n[e + 1].percent - o);
      } else {
        var _o = L * 100 / (f - a);

        return Math.min(n[e - 1].percent + _o, 100);
      }
    },
        wn = function wn(e) {
      if (!(h || n.length <= 1 || f === a)) if (e === n.length - 1) {
        var o = g * 100 / (f - a);
        return Math.min(n[e - 1].percent + o, 100);
      } else {
        var _o2 = L * 100 / (f - a);

        return Math.max(0, n[e + 1].percent - _o2);
      }
    },
        J = function J(e) {
      var o;

      if (typeof x == "function") {
        var u = Ee(0, 100, a, f, e);
        o = x(u, e);
      } else o = x;

      if (B(o)) {
        var _u = f - a;

        return o = _u === 0 ? 0 : o * 100 / _u, o;
      }
    },
        K = function K(e) {
      if (e === void 0) return;
      var o = Ee(0, 100, a, f, e);
      return p !== void 0 ? p[Math.round(o)] : Ut(o, A);
    },
        Q = function Q() {
      return p !== void 0 ? p[a] : a;
    },
        Z = function Z() {
      return p !== void 0 ? p[f] : f;
    },
        Me = function Me() {
      return x;
    },
        Dn = function Dn(e) {
      var o;
      return e <= 0 || h ? Q() : (o = K(n[e - 1].percent)) != null ? o : "";
    },
        Cn = function Cn(e) {
      var o;
      return n.length <= 1 || e >= n.length - 1 || h ? Z() : (o = K(n[e + 1].percent)) != null ? o : "";
    },
        ut = function ut() {
      return n.map(function (e) {
        return e.percent;
      });
    },
        dt = function dt() {
      return n.map(function (e) {
        return K(e.percent);
      });
    },
        ct = function ct() {
      return n.map(function (e) {
        return e.$pointer;
      });
    },
        pt = function pt() {
      return a;
    },
        bt = function bt() {
      return f;
    },
        Le = function Le() {
      return p;
    },
        we = function we() {
      return b;
    },
        De = function De() {
      return A;
    },
        Ce = function Ce() {
      return L;
    },
        ke = function ke() {
      return g;
    },
        kn = function kn(e) {
      return tt[e];
    },
        He = function He() {
      return k;
    },
        Re = function Re() {
      return c;
    },
        Ie = function Ie() {
      return M;
    },
        Be = function Be() {
      return H;
    },
        Oe = function Oe() {
      return h;
    },
        Fe = function Fe() {
      return T;
    },
        R = function R(e, o) {
      if (o === void 0) return;
      var u = J(o);
      u !== void 0 && (o = Xe(o, u));
      var v = n[e];

      if (!!v) {
        v.updatePosition(o, Ln(e), wn(e), b, k, c), d == null || d.updatePosition(b, n.map(function (y) {
          return y.percent;
        }), k, c), z();

        var _iterator18 = _createForOfIteratorHelper(n),
            _step18;

        try {
          for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
            var y = _step18.value;
            var S = K(y.percent);
            S !== void 0 && (y.setAttr("aria-valuenow", S.toString()), y.setAttr("aria-valuetext", S.toString()));
          }
        } catch (err) {
          _iterator18.e(err);
        } finally {
          _iterator18.f();
        }

        Rn(), qt(r, n.map(function (y) {
          return K(y.percent);
        }));
      }
    },
        O = function O() {
      for (var e = 0; e < n.length; e++) {
        R(e, n[e].percent);
      }
    },
        Hn = function Hn(e, o) {
      a = p !== void 0 ? 0 : E(e, $e), f = p !== void 0 ? p.length - 1 : E(o, Y), _(a), $(f);
    },
        Rn = function Rn() {
      var e, o;

      for (var u = 0; u < n.length; u++) {
        var v = n[u];
        v.setAttr("aria-valuemin", ((e = Dn(u)) != null ? e : "").toString()), v.setAttr("aria-valuemax", ((o = Cn(u)) != null ? o : "").toString());
      }
    },
        _ = function _(e) {
      a = E(e, $e), a > f && (f = a + Y), O();
    },
        $ = function $(e) {
      f = E(e, Y), f < a && (f = a + Y), O();
    },
        gt = function gt(e) {
      h = !0;

      for (var o = 0; o < e.length; o++) {
        ee(e[o], o);
      }

      h = !1;

      for (var _o3 = 0; _o3 < e.length; _o3++) {
        ee(e[_o3], _o3);
      }
    },
        ee = function ee(e, o) {
      var u;
      p !== void 0 ? (u = e == null ? 0 : Xt(e, p), u === -1 && (u = 0)) : (u = E(e, a), u < a && (u = a), u > f && (u = f));
      var v = Ee(a, f, 0, 100, u);
      R(o, v);
    },
        te = function te(e) {
      if (e == null) {
        x = void 0;
        return;
      }

      if (typeof e == "function") {
        x = e, O();
        return;
      }

      if (B(e)) {
        x = E(e, 1);
        var o = Math.abs(f - a);
        x > o && (x = void 0), O();
        return;
      }

      x = void 0;
    },
        Ne = function Ne(e) {
      h = e, O();
    },
        Ve = function Ve(e) {
      (!B(e) || e < 0) && (e = 0), L = e;
    },
        Ue = function Ue(e) {
      (!B(e) || e < 0) && (e = 1 / 0), g = e;
    },
        ze = function ze(e) {
      M = e, i.classList.toggle("disabled", M), M ? i.setAttribute("aria-disabled", "true") : i.hasAttribute("aria-disabled") && i.removeAttribute("aria-disabled");
    },
        ft = function ft(e) {
      H = e;
    },
        We = function We(e) {
      if (e == null) {
        p = void 0;
        return;
      }

      if (p = Gt(e), p === void 0 || p.length <= 0) {
        p = void 0;
        return;
      }

      _(0), $(p.length - 1), x === void 0 && te(1);
    },
        Ke = function Ke(e) {
      var v;
      typeof e == "string" ? b = e.trim().toLowerCase() === I ? I : N : b = N;
      var o = (v = r.shadowRoot) == null ? void 0 : v.querySelector(".range-slider-box");
      if (!o) return;
      o.className = "range-slider-box type-".concat(b), O();
      var u = b === I ? "vertical" : "horizontal";

      var _iterator19 = _createForOfIteratorHelper(n),
          _step19;

      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var y = _step19.value;
          y.setAttr("aria-orientation", u);
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }
    },
        je = function je(e) {
      k = e, n.length > 1 && _e(n, k, r), O(), z();
    },
        qe = function qe(e) {
      c = e, n.length > 1 && _e(n, c, r), O(), z();
    },
        Ge = function Ge(e) {
      A = E(e, U), A < 0 && (A = U), z();
    },
        mt = function mt(e) {
      e == null || e.toString().trim().toLowerCase() === "false" ? (C = void 0, i.style.removeProperty(Ye), i.classList.remove(W)) : (C = e.toString(), i.style.setProperty(Ye, C), i.classList.add(W));
    },
        ht = function ht(e, o) {
      var u = n[e];
      !u || (u.setAttr("aria-label", o), tt[e] = o);
    },
        ne = function ne(e) {
      if (w = void 0, n.length <= 1) {
        T = !1, i.classList.remove(Qe);
        return;
      }

      T = e, i.classList.toggle(Qe, T);
    },
        In = function In() {
      ze(D(r.getAttribute(ve))), H = D(r.getAttribute(ye));
      var e = j(r, /^pointer([0-9]*)-disabled$/, function (o) {
        return D(o);
      });

      var _iterator20 = _createForOfIteratorHelper(e),
          _step20;

      try {
        for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
          var o = _step20.value;
          var u = o[0];
          !n[u] || (n[u].disabled = o[1]);
        }
      } catch (err) {
        _iterator20.e(err);
      } finally {
        _iterator20.f();
      }
    },
        Bn = function Bn() {
      var e = j(r, /^aria-label([0-9]*)$/);

      var _iterator21 = _createForOfIteratorHelper(e),
          _step21;

      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var o = _step21.value;
          var u = o[0];
          ht(u, o[1]);
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }
    },
        On = function On(e) {
      var o = n.length,
          u = n[o - 1].$pointer,
          v = u.cloneNode(!0);
      u.after(v);
      var y = X(r, v, o);
      return y.setCallbacks(ot, st, at, lt), n.push(y), ee(e, o), O(), z(), o;
    },
        Fn = function Fn() {
      var e = n.length,
          o = n[e - 1];
      return o ? (o.destroy(), n.pop(), n.length <= 1 && ne(!1), O(), z(), e - 1) : -1;
    };

    return function () {
      var o, u;

      var _iterator22 = _createForOfIteratorHelper(n),
          _step22;

      try {
        for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
          var v = _step22.value;
          v.setCallbacks(ot, st, at, lt);
        }
      } catch (err) {
        _iterator22.e(err);
      } finally {
        _iterator22.f();
      }

      var e = (o = r.shadowRoot) == null ? void 0 : o.querySelector(".panel-fill");
      e && (d = Yt(e)), Ke(r.getAttribute(ge)), je(D(r.getAttribute(me))), qe(D(r.getAttribute(he))), Hn(r.getAttribute(de), r.getAttribute(ce)), te(r.getAttribute(pe)), We(r.getAttribute(ue)), gt(t.map(function (v) {
        return v[1];
      })), Ne(D(r.getAttribute(oe))), Ve(E(r.getAttribute(se), 0)), Ue(E(r.getAttribute(ae), 1 / 0)), ne(D(r.getAttribute(le))), Ge(E(r.getAttribute(be), U)), In(), Bn(), m = mn(r, i, n), mt((u = r.getAttribute(xe)) != null ? u : xn), i.addEventListener("mousedown", nt), i.addEventListener("mouseup", Ae), i.addEventListener("touchmove", V), i.addEventListener("touchstart", V), document.addEventListener("wheel", it, {
        passive: !1
      }), l = hn(r, Mn, {
        setValues: gt,
        setMin: _,
        setMax: $,
        setStep: te,
        setPointersOverlap: Ne,
        setPointersMinDistance: Ve,
        setPointersMaxDistance: Ue,
        setDisabled: ze,
        setType: Ke,
        setRightToLeft: je,
        setBottomToTop: qe,
        setRound: Ge,
        setKeyboardDisabled: ft,
        setRangeDragging: ne,
        setData: We
      }, {
        getPercents: ut,
        getValues: dt,
        getPointerElements: ct,
        getMin: pt,
        getMax: bt,
        getStep: Me,
        getData: Le,
        getType: we,
        getRound: De,
        getTextMin: Q,
        getTextMax: Z,
        isRightToLeft: He,
        isBottomToTop: Re,
        isDisabled: Ie,
        isKeyboardDisabled: Be,
        isPointersOverlap: Oe,
        isRangeDraggingEnabled: Fe,
        getPointersMinDistance: Ce,
        getPointersMaxDistance: ke
      }), l.init();
    }(), {
      get pointers() {
        return n;
      },

      get styles() {
        return m;
      },

      get pluginsManager() {
        return l;
      },

      get min() {
        return Q();
      },

      get max() {
        return Z();
      },

      get step() {
        return Me();
      },

      get pointersOverlap() {
        return Oe();
      },

      set pointersOverlap(e) {
        Ne(e);
      },

      get pointersMinDistance() {
        return Ce();
      },

      set pointersMinDistance(e) {
        Ve(e);
      },

      get pointersMaxDistance() {
        return ke();
      },

      set pointersMaxDistance(e) {
        Ue(e);
      },

      get disabled() {
        return Ie();
      },

      set disabled(e) {
        ze(e);
      },

      get data() {
        return Le();
      },

      get type() {
        return we();
      },

      set type(e) {
        Ke(e);
      },

      get rightToLeft() {
        return He();
      },

      set rightToLeft(e) {
        je(e);
      },

      get bottomToTop() {
        return Re();
      },

      set bottomToTop(e) {
        qe(e);
      },

      get round() {
        return De();
      },

      set round(e) {
        Ge(e);
      },

      get animateOnClick() {
        return C;
      },

      set animateOnClick(e) {
        mt(e);
      },

      get keyboardDisabled() {
        return Be();
      },

      set keyboardDisabled(e) {
        ft(e);
      },

      get rangeDragging() {
        return Fe();
      },

      set rangeDragging(e) {
        ne(e);
      },

      setMin: _,
      setMax: $,
      setValue: ee,
      setStep: te,
      setData: We,
      getTextValue: K,
      setAriaLabel: ht,
      getAriaLabel: kn,
      addPointer: On,
      removePointer: Fn,
      destroy: function destroy() {
        i.removeEventListener("mousedown", nt), i.removeEventListener("mouseup", Ae), i.removeEventListener("touchmove", V), i.removeEventListener("touchstart", V), document.removeEventListener("wheel", it);

        var _iterator23 = _createForOfIteratorHelper(n),
            _step23;

        try {
          for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
            var e = _step23.value;
            e.destroy();
          }
        } catch (err) {
          _iterator23.e(err);
        } finally {
          _iterator23.f();
        }

        l == null || l.destroy();
      }
    };
  };

  var Sn = function Sn(r, i, t) {
    var n = Je.find(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 4),
          l = _ref2[0],
          a = _ref2[1],
          f = _ref2[2],
          x = _ref2[3];

      return a.replace("#", "") === i.replace(/\d+/g, "");
    });

    if (n && r.styles) {
      var _n2 = _slicedToArray(n, 4),
          l = _n2[0],
          a = _n2[1],
          f = _n2[2],
          x = _n2[3],
          p = i.replace(/\D/g, "").trim(),
          b = p === "" || p === "0" || p === "1" ? 0 : E(p, 0) - 1;

      r.styles.setStyle(l, t, b);
      return;
    }

    switch (r && r.pluginsManager && r.pluginsManager.onAttrChange(i, t), i) {
      case de:
        {
          r.setMin(t);
          break;
        }

      case ce:
        {
          r.setMax(t);
          break;
        }

      case pe:
        {
          r.setStep(t);
          break;
        }

      case oe:
        {
          r.pointersOverlap = D(t);
          break;
        }

      case se:
        {
          r.pointersMinDistance = E(t, 0);
          break;
        }

      case le:
        {
          r.rangeDragging = D(t);
          break;
        }

      case ae:
        {
          r.pointersMaxDistance = E(t, 1 / 0);
          break;
        }

      case ve:
        {
          r.disabled = D(t);
          break;
        }

      case ye:
        {
          r.keyboardDisabled = D(t);
          break;
        }

      case ue:
        {
          r.setData(t);
          break;
        }

      case ge:
        {
          r.type = t;
          break;
        }

      case me:
        {
          r.rightToLeft = D(t);
          break;
        }

      case he:
        {
          r.bottomToTop = D(t);
          break;
        }

      case be:
        {
          r.round = E(t, U);
          break;
        }

      case fe:
        {
          r.styles && (r.styles.theme = t);
          break;
        }

      case xe:
        {
          r.animateOnClick = t;
          break;
        }
    }

    var s = null;
    if (/^value([0-9]*)$/.test(i) && (s = "value"), /^pointer([0-9]*)-disabled$/.test(i) && (s = "pointer-disabled"), /^aria-label([0-9]*)$/.test(i) && (s = "aria-label"), /^pointer([0-9]*)-shape$/.test(i) && (s = "pointer-shape"), !s) return;
    var d = i.replace(/\D/g, "").trim(),
        m = d === "" || d === "0" || d === "1" ? 0 : E(d, 0) - 1;

    switch (s) {
      case "value":
        {
          r.setValue(t, m);
          break;
        }

      case "pointer-disabled":
        {
          var _l2 = r == null ? void 0 : r.pointers[m];

          if (!_l2) return;
          _l2.disabled = D(t);
          break;
        }

      case "aria-label":
        {
          r.setAriaLabel(m, t);
          break;
        }

      case "pointer-shape":
        {
          r.styles && r.styles.setPointerShape(m, t);
          break;
        }
    }
  };

  var et = /*#__PURE__*/function (_HTMLElement) {
    "use strict";

    _inherits(et, _HTMLElement);

    function et() {
      var _this;

      _classCallCheck(this, et);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(et).call(this));
      ie(_assertThisInitialized(_assertThisInitialized(_this)), "slider");
      ie(_assertThisInitialized(_assertThisInitialized(_this)), "_externalCSSList", []);
      ie(_assertThisInitialized(_assertThisInitialized(_this)), "_observer", null);

      _this.attachShadow({
        mode: "open"
      });

      return _this;
    }

    _createClass(et, [{
      key: "addPointer",
      value: function addPointer(t) {
        var s;
        if (!this.slider) return;
        var n = (s = this.slider) == null ? void 0 : s.addPointer(t);
        Ze(this, this.slider, n, "value".concat(n + 1), "ariaLabel".concat(n + 1), "pointerShape".concat(n + 1), "pointer".concat(n + 1, "Disabled"));
      }
    }, {
      key: "removePointer",
      value: function removePointer() {
        var t;
        !this.slider || (t = this.slider) == null || t.removePointer();
      }
    }, {
      key: "addCSS",
      value: function addCSS(t) {
        if (!this.shadowRoot) return;
        var n = document.createElement("style");
        n.textContent = t, this.shadowRoot.appendChild(n);
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this2 = this;

        var d, m;
        if (!this.shadowRoot) return;
        this._externalCSSList = fn(this), this.shadowRoot.innerHTML = yt(xt, this._externalCSSList);
        var t = (d = this.shadowRoot) == null ? void 0 : d.querySelector(".pointer");
        if (!t) return;
        var n = (m = this.shadowRoot) == null ? void 0 : m.getElementById("range-slider");
        if (!n) return;
        var s = vn(this, t);
        this.slider = Pn(this, n, s), yn(this, this.slider), this._observer = new MutationObserver(function (l) {
          l.forEach(function (a) {
            var x;
            if (!_this2.slider || a.type !== "attributes") return;
            var f = a.attributeName;
            !f || Sn(_this2.slider, f, (x = _this2.getAttribute(f)) != null ? x : "");
          });
        }), this._observer.observe(this, {
          attributes: !0
        });
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        this._observer && this._observer.disconnect(), this.slider && this.slider.destroy();
      }
    }, {
      key: "step",
      set: function set(t) {
        this.slider && this.slider.setStep(t);
      },
      get: function get() {
        var t;
        return (t = this.slider) == null ? void 0 : t.step;
      }
    }, {
      key: "disabled",
      set: function set(t) {
        this.slider && (this.slider.disabled = t);
      },
      get: function get() {
        var t, n;
        return (n = (t = this.slider) == null ? void 0 : t.disabled) != null ? n : !1;
      }
    }, {
      key: "data",
      set: function set(t) {
        var n;
        (n = this.slider) == null || n.setData(t);
      },
      get: function get() {
        var t;
        return (t = this.slider) == null ? void 0 : t.data;
      }
    }, {
      key: "min",
      set: function set(t) {
        var n;
        (n = this.slider) == null || n.setMin(t);
      },
      get: function get() {
        var t;
        return (t = this.slider) == null ? void 0 : t.min;
      }
    }, {
      key: "max",
      set: function set(t) {
        var n;
        (n = this.slider) == null || n.setMax(t);
      },
      get: function get() {
        var t;
        return (t = this.slider) == null ? void 0 : t.max;
      }
    }, {
      key: "round",
      set: function set(t) {
        !this.slider || (this.slider.round = t);
      },
      get: function get() {
        var t, n;
        return (n = (t = this.slider) == null ? void 0 : t.round) != null ? n : U;
      }
    }, {
      key: "type",
      set: function set(t) {
        !this.slider || (this.slider.type = t != null ? t : N);
      },
      get: function get() {
        var t;
        return ((t = this.slider) == null ? void 0 : t.type) || N;
      }
    }, {
      key: "pointersOverlap",
      set: function set(t) {
        !this.slider || (this.slider.pointersOverlap = t);
      },
      get: function get() {
        var t, n;
        return (n = (t = this.slider) == null ? void 0 : t.pointersOverlap) != null ? n : !1;
      }
    }, {
      key: "pointersMinDistance",
      set: function set(t) {
        !this.slider || (this.slider.pointersMinDistance = t);
      },
      get: function get() {
        var t, n;
        return (n = (t = this.slider) == null ? void 0 : t.pointersMinDistance) != null ? n : 0;
      }
    }, {
      key: "pointersMaxDistance",
      set: function set(t) {
        !this.slider || (this.slider.pointersMaxDistance = t);
      },
      get: function get() {
        var t, n;
        return (n = (t = this.slider) == null ? void 0 : t.pointersMaxDistance) != null ? n : 1 / 0;
      }
    }, {
      key: "theme",
      set: function set(t) {
        !this.slider || !this.slider.styles || (this.slider.styles.theme = t);
      },
      get: function get() {
        var t, n, s;
        return (s = (n = (t = this.slider) == null ? void 0 : t.styles) == null ? void 0 : n.theme) != null ? s : null;
      }
    }, {
      key: "rtl",
      set: function set(t) {
        !this.slider || (this.slider.rightToLeft = t);
      },
      get: function get() {
        var t, n;
        return (n = (t = this.slider) == null ? void 0 : t.rightToLeft) != null ? n : !1;
      }
    }, {
      key: "btt",
      set: function set(t) {
        !this.slider || (this.slider.bottomToTop = t);
      },
      get: function get() {
        var t, n;
        return (n = (t = this.slider) == null ? void 0 : t.bottomToTop) != null ? n : !1;
      }
    }, {
      key: "keyboardDisabled",
      set: function set(t) {
        !this.slider || (this.slider.keyboardDisabled = t);
      },
      get: function get() {
        var t, n;
        return (n = (t = this.slider) == null ? void 0 : t.keyboardDisabled) != null ? n : !1;
      }
    }, {
      key: "animateOnClick",
      set: function set(t) {
        !this.slider || (this.slider.animateOnClick = t);
      },
      get: function get() {
        var t;
        return (t = this.slider) == null ? void 0 : t.animateOnClick;
      }
    }, {
      key: "rangeDragging",
      get: function get() {
        var t, n;
        return (n = (t = this.slider) == null ? void 0 : t.rangeDragging) != null ? n : !1;
      },
      set: function set(t) {
        this.slider && (this.slider.rangeDragging = D(t));
      }
    }, {
      key: "externalCSSList",
      get: function get() {
        return this._externalCSSList;
      }
    }]);

    return et;
  }(_wrapNativeSuper(HTMLElement)),
      Te = et;

  window.tcRangeSlider = Te;
  customElements.get("toolcool-range-slider") || customElements.define("toolcool-range-slider", Te);
  customElements.get("tc-range-slider") || customElements.define("tc-range-slider", /*#__PURE__*/function (_Te) {
    "use strict";

    _inherits(_class, _Te);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
    }

    return _class;
  }(Te));
})();